import clsx from "clsx";

import { Icon } from "~/assets/icons/Icon";

import styles from "./DynamicSettingsIcon.module.scss";

type DynamicSettingsIconProps = {
  isEditing: boolean;
};

// Component name is legacy — it now renders an edit pencil rather than a
// settings gear. Used by both the dashboard-level edit toggle in
// DashboardView and the per-widget edit toggle in DashboardViewWidget.
export const DynamicSettingsIcon = ({
  isEditing,
}: DynamicSettingsIconProps) => {
  return (
    <Icon
      iconName="EditIcon"
      className={clsx(styles.settingIcon, {
        [styles.settingIconEnabled]: isEditing,
      })}
    />
  );
};
